import {
  OuiBoxComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-display-value',
  imports: [OuiBoxComponent, OuiTextComponent, OuiStackComponent],
  templateUrl: './display-value.component.html',
  standalone: true,
})
export class DisplayValueComponent {
  label = input<string>();
}
